import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { MappedAreaActions } from '../actions';
import { MappedAreaService } from '../mapped-area.service';

@Injectable()
export class MappedAreaEffects {
  private actions$ = inject(Actions);
  private mappedAreaService = inject(MappedAreaService);

  loadMappedArea$ = createEffect(() => this.actions$
    .pipe(
      ofType(MappedAreaActions.loadMappedArea),
      exhaustMap(({ id }) => this.mappedAreaService
        .get(id)
        .pipe(
          map(mappedArea => MappedAreaActions.loadMappedAreaSuccess({ mappedArea })),
          catchError(error => of(MappedAreaActions.loadMappedAreaFailure({ error }))),
        ),
      ),
    ),
  );

  loadMappedAreas$ = createEffect(() => this.actions$
    .pipe(
      ofType(MappedAreaActions.loadMappedAreas),
      exhaustMap(({ destination }) => this.mappedAreaService
        .getAll({destination})
        .pipe(
          map(mappedAreas => MappedAreaActions.loadMappedAreasSuccess({ mappedAreas })),
          catchError(error => of(MappedAreaActions.loadMappedAreasFailure({ error }))),
        ),
      ),
    ),
  );
}
